import { styled, alpha } from "@mui/material/styles";
import { keyframes } from "@mui/material";
import {
    TreeView as MuiTreeView,
    TreeItem as MuiTreeItem,
    treeItemClasses,
} from "@mui/lab";

export const StyledTreeViewContainer = styled("div")(({ theme, fold, isFold }) => ({
    position: `relative`,
    height: `100%`,
}));
export const StyledTreeViewWrap = styled("div")(({ theme, fold, isFold }) => ({
    display: `inline-flex`,
    height: `100%`,
    position: `relative`,
    boxSizing: `border-box`,

    ...(fold
        ? {
              transition: `width 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
              overflowY: `hidden`,
              paddingRight: `45px`,
              ...(isFold
                  ? {
                        width: `78px`,
                        ".MuiTreeView-root": {
                            width: 0,
                            whiteSpace: `nowrap`,
                            opacity: 0,
                            overflowY: `hidden`,
                            transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 200ms`,
                        },
                        ".TreeAnimationButton": {
                            minWidth: `40px`,
                            padding: `0 10px`,
                            // transition: `min-width 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
                            ".text": {
                                display: `none`,
                            },
                            ".MuiButton-startIcon": {
                                margin: 0,
                            },
                        },
                        ".TreeAnimationTextField": {
                            opacity: 0,
                            transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, width 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
                        },
                    }
                  : {
                        width: 385,
                        transition: `width 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
                        ".MuiTreeView-root": {
                            maxWidth: `340px`,
                            width: `100%`,
                            opacity: 1,
                            overflowY: `auto`,
                            // DAM-646: 스크롤바 생길 때 콘텐츠 밀림 방지
                            scrollbarGutter: "stable",
                            transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 200ms`,
                        },
                        ".TreeAnimationTextField": {
                            opacity: 1,
                            transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, width 200ms cubic-bezier(0.4, 0, 0.2, 1) 200ms`,
                        },
                        ".TreeAnimationButton": {
                            // minWidth: `132px`,
                            // transition: `min-width 200ms cubic-bezier(0.4, 0, 0.2, 1) 300ms`,
                            ".text": {
                                display: `block`,
                            },
                        },
                        [theme.breakpoints.down("lg")]: {
                            position: `absolute`,
                            left: 0,
                            top: 0,
                            bottom: 0,
                            right: 0,
                            zIndex: 2,
                        },
                    }),
          }
        : {
              width: `100%`,
              flex: 1,
          }),
}));

export const StyledTreeViewContent = styled("div")(({ theme, isFold }) => ({
    display: `flex`,
    flexDirection: `column`,
    flexWrap: `nowrap`,
    width: `100%`,
    backgroundColor: theme.palette.common.white,
}));

export const StyledTreeViewFoldButton = styled("div")(({ theme, isFold }) => ({
    display: `inline-flex`,
    position: `absolute`,
    right: `0`,
    top: 0,
    bottom: 0,
    alignItems: `center`,
    justifyContent: `center`,
    "&:before,&:after": {
        content: '""',
        display: `block`,
        position: `absolute`,
        top: `0`,
        bottom: `0`,
        opacity: 0,
        transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)`,
    },
    "&:before": {
        right: `13px`,
        width: 32,
        backgroundColor: theme.palette.common.white,
    },
    "&:after": {
        left: `50%`,
        width: 12,
        boxShadow: `-5px 0 6px 0 rgba(0, 0, 0, 0.1)`,
    },
    "&:hover": {
        "&:before,&:after": {
            opacity: 1,
        },
        button: {
            opacity: 1,
        },
    },
    [theme.breakpoints.down("lg")]: {
        "&:before,&:after": {
            opacity: 1,
        },
    },
    ...(isFold == true && {
        "&:before,&:after": {
            content: '""',
            display: `block`,
            position: `absolute`,
            top: `0`,
            bottom: `0`,
            transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)`,
        },
        "&:before": {
            left: `0`,
            width: 13,
            backgroundColor: theme.palette.common.white,
        },
        "&:after": {
            left: `50%`,
            width: 12,
            boxShadow: `-5px 0 6px 0 rgba(0, 0, 0, 0.1)`,
        },
    }),
    button: {
        position: `relative`,
        zIndex: `1`,
        display: `inline-flex`,
        alignItems: `center`,
        justifyContent: `center`,
        margin: 0,
        padding: 0,
        border: 0,
        width: `26px`,
        height: `26px`,
        boxShadow: `0 3px 3px 0 rgba(0, 0, 0, 0.12)`,
        borderRadius: `100%`,
        transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)`,
        ...(isFold
            ? {
                  opacity: 1,
                  backgroundColor: theme.palette.secondary[600],
                  color: theme.palette.common.white,
                  "&:hover": {
                      backgroundColor: theme.palette.greySecondary[700],
                  },
                  "&:active": {
                      backgroundColor: theme.palette.greySecondary[300],
                  },
              }
            : {
                  opacity: 0,
                  backgroundColor: theme.palette.common.white,
                  border: `1px solid ${theme.palette.greySecondary[100]}`,
                  "&:hover": {
                      backgroundColor: theme.palette.greySecondary[50],
                  },
                  [theme.breakpoints.down("lg")]: {
                      opacity: 1,
                  },
              }),
    },
}));

export const StyledTreeView = styled(MuiTreeView, {
    shouldForwardProp: (prop) => !["fold"].includes(String(prop)),
})(({ theme, fold }) => ({
    // height: 110,
    flexGrow: 1,
    width: `100%`,
    height: `100%`,
}));

export const StyledTreeItemRoot = styled(MuiTreeItem, {
    shouldForwardProp: (prop) => !["labelIcon"].includes(String(prop)),
})(({ theme }) => {
    // 이동 완료된 폴더 행 강조 — .overCurrent와 동일 토큰으로 유지 후 서서히 소멸 (fill 미지정이라 종료 시 원래 스타일로 복귀)
    const revealFlash = keyframes({
        "0%, 60%": { backgroundColor: alpha(theme.palette.primary[100], 0.48) },
        "100%": { backgroundColor: "transparent" },
    });

    return {
        color: theme.palette.text.primary,
        // 직계 자식 셀렉터 필수 — 자손 셀렉터면 이동 폴더의 하위 행까지 전부 flash됨
        "&.revealHighlight": {
            [`& > .${treeItemClasses.content}`]: {
                animation: `${revealFlash} 1.6s ease-out`,
            },
        },
        [`& .${treeItemClasses.content}`]: {
            color: theme.palette.text.primary,
            borderTopRightRadius: theme.spacing(2.5),
            borderBottomRightRadius: theme.spacing(2.5),
            paddingRight: theme.spacing(1),
            border: "1px solid transparent",
            fontWeight: theme.typography.fontWeightRegular,
            boxSizing: `border-box`,
            paddingTop: `7px`,
            paddingBottom: `7px`,
            paddingLeft: `16px`,
            "&:hover, &.clicked": {
                backgroundColor: alpha(theme.palette.secondary.main, 0.04),
                [`& .${treeItemClasses.label}`]: {
                    textDecoration: "underline",
                },
                "#menu-button": {
                    opacity: 1,
                    "&:hover": {
                        backgroundColor: alpha(theme.palette.secondary[800], 0.08),
                    },
                },
            },
            // 드래그 중 강조되는 두 행 — 드롭 대상(.overCurrent)과 드래그 소스(.dragSource)는
            // border가 완전히 동일하고, 배경도 같은 primary[100] 토큰에 alpha만 다르다 (Figma 28506:391777)
            "&.overCurrent, &.dragSource": {
                border: `1px solid ${alpha(theme.palette.primary.main, 0.6)}`,
            },
            "&.overCurrent": {
                backgroundColor: alpha(theme.palette.primary[100], 0.48),
            },
            // 잡은 폴더는 선택 행(.Mui-selected)과 동일한 alpha — 드롭 대상보다 옅게
            "&.dragSource": {
                backgroundColor: alpha(theme.palette.primary[100], 0.2),
            },
            // 인디케이터를 행 경계에 걸쳐 그려, 위 행 하단 존과 아래 행 상단 존이 같은 한 줄로 보이게 함.
            // 시작점(left)은 삽입될 depth의 들여쓰기에 맞춰 CustomContent가 CSS 변수로 지정
            "&.dropBefore, &.dropAfter": {
                position: `relative`,
                "&::after": {
                    content: '""',
                    position: `absolute`,
                    left: `var(--drop-indicator-left, 0px)`,
                    right: 0,
                    height: `2px`,
                    backgroundColor: theme.palette.primary.main,
                    zIndex: 1,
                    pointerEvents: `none`,
                },
                "&::before": {
                    content: '""',
                    position: `absolute`,
                    left: `var(--drop-indicator-left, 0px)`,
                    width: `8px`,
                    height: `8px`,
                    borderRadius: `50%`,
                    backgroundColor: theme.palette.primary.main,
                    zIndex: 1,
                    pointerEvents: `none`,
                },
            },
            "&.dropBefore::after": {
                top: `-2px`,
            },
            // 앵커 원(8px) 중심을 2px 선의 세로 중심에 정렬
            "&.dropBefore::before": {
                top: `-5px`,
            },
            "&.dropAfter::after": {
                bottom: `-2px`,
            },
            "&.dropAfter::before": {
                bottom: `-5px`,
            },
            '&[draggable="true"]': {
                cursor: `grab`,
            },
            "&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused": {
                backgroundColor: alpha(theme.palette.primary[100], 0.2),
                [`& .${treeItemClasses.label}`]: {
                    fontWeight: "normal",
                    color: theme.palette.primary.main,
                },
            },
            "&.Mui-focused": {
                "#menu-button": {
                    "&:hover": {
                        backgroundColor: alpha(theme.palette.secondary[800], 0.12),
                    },
                },
            },
            "&.Mui-selected": {
                "#menu-button": {
                    "&:hover": {
                        backgroundColor: alpha(theme.palette.secondary[800], 0.16),
                    },
                },
            },
            [".spacing"]: {
                minWidth: theme.spacing(2),
                width: theme.spacing(2),
            },
        },
        [`& .${treeItemClasses.label}`]: {
            paddingLeft: `0`,
            whiteSpace: `nowrap`,
            overflow: `hidden`,
            textOverflow: `ellipsis`,
            paddingRight: `12px`,
        },
        ".MuiTreeItem-content > .MuiBox-root ": {
            padding: `0 12px 0 4px`,
        },
        [`& .${treeItemClasses.iconContainer}`]: {
            marginRight: `8px !important`,
        },
        //캐럿은 폴더 아이콘과 iconContainer 클래스를 공유하므로 별도 클래스로만 히트 영역을 넓힌다.
        //레이아웃을 밀지 않도록 가상요소로 확장하고, 폴더 아이콘과의 8px 간격 안쪽까지만 늘린다
        "& .expandToggle": {
            position: `relative`,
            "&::before": {
                content: `""`,
                position: `absolute`,
                top: `-4px`,
                bottom: `-4px`,
                left: `-4px`,
                right: `-4px`,
            },
        },
        [`& .${treeItemClasses.group}`]: {
            marginLeft: 0,
            // [`& .${treeItemClasses.content}`]: {
            //   paddingLeft: theme.spacing(2),
            // },
        },
        "#menu-button": {
            opacity: 0,
            '&[aria-expanded="true"]': {
                opacity: 1,
            },
        },
    };
});
